import React, { createContext, useContext, useState } from 'react';

const PlatformContext = createContext();

export const usePlatform = () => useContext(PlatformContext);

const detectMobilePlatform = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('platform') === 'mobile') {
    sessionStorage.setItem('platform', 'mobile');
    return true;
  }
  return sessionStorage.getItem('platform') === 'mobile';
};

export const PlatformProvider = ({ children }) => {
  const [isMobileApp] = useState(detectMobilePlatform);

  return (
    <PlatformContext.Provider value={{ isMobileApp }}>
      {children}
    </PlatformContext.Provider>
  );
};
